import {
  gotoSignedInApp,
  ValidateUserLoader,
  ValidateUserProvider,
} from '@amagimedia/commons';
import type { FC } from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';
import { BrowserRouter, Redirect, Route, Switch } from 'react-router-dom';
import { LoadExternalServices } from './components/LoadExternalServices';
import { STVLandingApp } from './components/STVLandingApp';
import { STVNowApp } from './components/STVNowApp';
import { VerifiedLoginRoute } from './components/VerifiedLoginRoute';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: false,
    },
  },
});

export const App: FC = () => {
  return (
    <QueryClientProvider client={queryClient}>
      <ValidateUserLoader
        render={(data) => (
          <ValidateUserProvider
            data={data}
            render={(loginData) => {
              if (
                loginData &&
                loginData.account_domain &&
                window.location.host.split('.')[0] !== 'local' &&
                loginData.account_domain !== window.location.host.split('.')[0]
              ) {
                gotoSignedInApp(loginData);
                return null;
              }
              return (
                <>
                  <BrowserRouter>
                    <Switch>
                      <Route path="/now" component={STVNowApp} />
                      <VerifiedLoginRoute
                        path={[
                          '/',
                          '/signup/:id/email-sent',
                          '/signup/:id/verify',
                          '/signup',
                          '/setup',
                          '/reset-password',
                        ]}
                        component={STVLandingApp}
                      />
                      <Redirect to="/" />
                    </Switch>
                  </BrowserRouter>
                  <LoadExternalServices loginData={data} />
                </>
              );
            }}
          />
        )}
      />
    </QueryClientProvider>
  );
};
